exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switchery.switchery-default {\n  margin: 0 10px;\n}\n.switchery.switchery-default small {\n  top: -6px;\n  left: -2px !important;\n  height: 32px;\n  width: 32px;\n}\n.general-switch:checked + .switchery.switchery-default small {\n  left: 20px !important;\n}", ""]);

// exports
